export enum ImageKind {
  POST = 'post',
  BUSINESS = 'business',
  REVIEW = 'review',
}
